import { useEffect } from 'react'
import type { MarbleGame } from 'src/types/domain/Game'

export const usePreloadGameImages = (games: MarbleGame[]) => {
  useEffect(() => {
    games.forEach((game) => {
      const url = game.track.background
      const img = new Image()
      img.src = url
    })
  }, [games])
}
